export default __webpack_public_path__ + "static/logo-071709bbae360e0a6044127ea1c674e9.svg";